import { motion } from "framer-motion";
import HormoneImg from "../assets/hormone.png";
import PeriodImg from "../assets/periods.png";
import WeightImg from "../assets/weight.png";
import SkinImg from "../assets/skin.png";
import FertilityImg from "../assets/fertility.png";
import StressImg from "../assets/stress.png";

const WeHelpWith = () => {
  return (
    <section id="pcod-help" className="py-20 w-full bg-pink-50">
      <div className="max-w-6xl mx-auto text-center mb-12">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="text-3xl md:text-5xl font-bold text-pink-600 text-center my-16"
        >
          We are Best for
        </motion.h2>
      </div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        className="max-w-6xl w-full flex flex-col justify-center mx-auto"
      >
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.3,
            delay: 1 * 0.1,
            ease: "easeOut",
          }}
          className="flex flex-col sm:flex-row"
        >
          <div className="bg-pink-200 hover:bg-white transition-all duration-300 shadow-sm overflow-hidden f justify-between flex flex-col items-center text-center p-6 flex-1">
            <h3 className="text-2xl md:text-4xl font-bold text-[#e91e63] mb-2">
              Hormonal Balance Restoration
            </h3>
            <div className="w-full flex justify-center items-center flex-1">
              <img
                src={HormoneImg}
                alt={"Hormonal Balance Restoration"}
                className="max-w-full max-h-56 object-contain"
              />
            </div>
            <p className="text-gray-800 text-md leading-relaxed">
              We focus on bringing your hormones back to their natural rhythm
              through personalized care, nutrition guidance, and lifestyle
              correction.
            </p>
          </div>
          <div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.3,
              delay: 1 * 0.1,
              ease: "easeOut",
            }}
            className="bg-pink-50 hover:bg-white transition-all duration-300 overflow-hidden flex flex-col justify-between items-center text-center p-6 flex-1"
          >
            {" "}
            <h3 className="text-2xl md:text-4xl font-bold text-[#e91e63] mb-2">
              Managing Irregular Periods
            </h3>
            <div className="w-full flex justify-center items-center flex-1">
              <img
                src={PeriodImg}
                alt={"Managing Irregular Periods"}
                className="max-w-full max-h-56 object-contain"
              />
            </div>
            <p className="text-gray-800 text-md leading-relaxed">
              Our specialists help regulate your menstrual cycle safely and
              effectively, reducing discomfort and restoring confidence in your
              body’s rhythm.
            </p>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.3,
            delay: 1 * 0.1,
            ease: "easeOut",
          }}
          className="flex flex-col md:flex-row"
        >
          <div className="bg-pink-200 md:bg-pink-50 hover:bg-white transition-all duration-300 overflow-hidden justify-between flex flex-col items-center text-center p-6 flex-1">
            <h3 className="text-2xl md:text-4xl font-bold text-[#e91e63] mb-2">
              Reducing Unwanted Weight Gain
            </h3>
            <div className="w-full flex justify-center items-center flex-1">
              <img
                src={WeightImg}
                alt={"Reducing Unwanted Weight Gain"}
                className="max-w-full max-h-56 object-contain"
              />
            </div>

            <p className="text-gray-800 text-md leading-relaxed">
              Through tailored diet plans and activity guidance, we help you
              control weight gain linked to insulin resistance and hormonal
              changes.
            </p>
          </div>
          <div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.3,
              delay: 1 * 0.1,
              ease: "easeOut",
            }}
            className="bg-pink-50 md:bg-pink-200 hover:bg-white transition-all duration-300 shadow-sm overflow-hidden flex flex-col justify-between items-center text-center p-6 flex-1"
          >
            <h3 className="text-2xl md:text-4xl font-bold text-[#e91e63] mb-2">
              Treating Skin & Hair Concerns
            </h3>
            <div className="w-full flex justify-center items-center flex-1">
              <img
                src={SkinImg}
                alt={"Treating Skin & Hair Concerns"}
                className="max-w-full max-h-56 object-contain"
              />
            </div>

            <p className="text-gray-800 text-md leading-relaxed">
              We address acne, hair thinning, and unwanted hair growth from the
              root cause — balancing internal health for visible outer results.
            </p>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.3,
            delay: 1 * 0.1,
            ease: "easeOut",
          }}
          className="flex flex-col md:flex-row"
        >
          <div className="bg-pink-200 hover:bg-white transition-all duration-300 shadow-sm overflow-hidden f justify-between flex flex-col items-center text-center p-6 flex-1">
            <h3 className="text-2xl md:text-4xl font-bold text-[#e91e63] mb-2">
              Improving Fertility Health
            </h3>
            <div className="w-full flex justify-center items-center flex-1">
              <img
                src={FertilityImg}
                alt={"Improving Fertility Health"}
                className="max-w-full max-h-56 object-contain"
              />
            </div>

            <p className="text-gray-800 text-md leading-relaxed">
              With focused treatment and hormonal optimization, we support you
              on your fertility journey, improving ovulation and reproductive
              wellness.
            </p>
          </div>
          <div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.3,
              delay: 1 * 0.1,
              ease: "easeOut",
            }}
            className="bg-pink-50 hover:bg-white transition-all duration-300 overflow-hidden flex flex-col justify-between items-center text-center p-6 flex-1"
          >
            <h3 className="text-2xl md:text-4xl font-bold text-[#e91e63] mb-2">
              Managing Stress & Lifestyle Factors
            </h3>
            <div className="w-full flex justify-center items-center flex-1">
              <img
                src={StressImg}
                alt={"Managing Stress & Lifestyle Factors"}
                className="max-w-full max-h-56 object-contain"
              />
            </div>

            <p className="text-gray-800 text-md leading-relaxed">
              We guide you to build healthier habits, reduce stress, and improve
              sleep — all essential elements in long-term PCOD management.
            </p>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default WeHelpWith;
